// 草稿箱管理
import {contractApi} from "@/axios";
//获取草稿箱信息
export function getDraftPage(params,data){
    return contractApi({
        url:'/draft-box/page',
        method:'post',
        params:params,
        data:data
    })
}
//添加草稿
export function addDraft(data){
    return contractApi({
        url:'/draft-box',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改草稿
export function editDraft(formData){
    return contractApi({
        url:'/draft-box',
        method:'put',
        data:formData,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
// 删除草稿
export function deleteDraft(params){
    return contractApi({
        url:'/draft-box',
        method:'delete',
        params: params
    })
}

//下载附件
export function downloadAttachment(id,annexType,fileName) {
    return contractApi({
        url: '/draft-box/attachment/' + id + '/' + annexType + (fileName?'/':'') + fileName,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//下载项目附件
export function downloadProjectDraft(id, projectMainTypeId) {
    return contractApi({
        url: `/draft-box/project-annex/${id}/${projectMainTypeId}`,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}